import { render, staticRenderFns } from "./LinkResolver.vue?vue&type=template&id=52d2db02"
import script from "./LinkResolver.vue?vue&type=script&lang=js"
export * from "./LinkResolver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports